import React, { Component } from 'react';
import {
  Button,
  ButtonToolbar,
} from 'react-bootstrap';
import appHistory from '../../history';
import Page from '../Page/Banner';
import UserStore from '../../stores/UserStore';
import './VerifyEmail.css';

class VerifyEmail extends Component {
  constructor(props) {
    super(props);
    UserStore.sendEmailVerification();
    this.state = { disableSendAgainButton: true };
    this.interval = null;
    this.timeout = null;
    this.setTimeout();
    this.pullVerificationState();
  }

  componentWillUnmount() {
    this.clearTimeout();
    this.clearInterval();
  }

  render() {
    const disableSendAgainButton = this.state.disableSendAgainButton;
    return (
      <Page>
        <div className="VerifyEmail-container">
          <div className="VerifyEmail-title">
            Verify your e-mail
          </div>
          <div className="VerifyEmail-body">
            <p>
              Please check your e-mail for a verification link.
              Wait for a little bit if you don't get it right away.
            </p>
          </div>
          <div className="VerifyEmail-button">
            <ButtonToolbar>
              <Button bsStyle="primary"
                onClick={this.sendEmailVerification}
                disabled={disableSendAgainButton}>
                I did not get the e-mail
              </Button>
            </ButtonToolbar>
          </div>
        </div>
      </Page>
    );
  }

  sendEmailVerification = () => {
    this.setState({ disableSendAgainButton: true });
    UserStore.sendEmailVerification().then(() => {
      this.pullVerificationState();
    });
  }

  clearTimeout = () => {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  clearInterval = () => {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  setTimeout = () => {
    this.timeout = window.setTimeout(() => {
      this.setState({ disableSendAgainButton: false });
      this.clearInterval();
      this.clearTimeout();
    }, 20 * 1000);
  }

  pullVerificationState = () => {
    // check verified state every 3 seconds
    this.interval = window.setInterval(() => {
      UserStore.reloadFirebaseUserCache().then(() => {
        const verified = UserStore.isEmailVerified();
        if (verified) {
          this.clearInterval();
          appHistory.push("/app");
        }
      });
    }, 3 * 1000);
  }
}

export default VerifyEmail;


// WEBPACK FOOTER //
// ./src/pages/VerifyEmail/VerifyEmail.js